import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import MainNavbar from "./components/MainNavbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import WhatsAppButton from "./components/WhatsAppButton";
import ar from "./language/ar.json";
import en from "./language/en.json";
import Wechat from "./components/qrwech"

const language = { en, ar };

export default function App() {
  const [lang, setLang] = useState("en");
  const t = (key) => language[lang][key] || key;

  return (
    <div className="d-flex flex-column min-vh-100">
      <MainNavbar t={t} lang={lang} setLang={setLang} />
      <main className="flex-grow-1">
        <Routes>
          <Route path="/" element={<Home t={t} langData={language[lang]} />} />
          <Route path="/services" element={<Services t={t} langData={language[lang]} />} />
          <Route path="/about" element={<About t={t} langData={language[lang]} />} />
          <Route path="/contact" element={<Contact t={t} langData={language[lang]} />} />
        </Routes>
      </main>
      <Footer t={t} />
      <>
      <Wechat />
      <WhatsAppButton />      
      </>
    </div>
  );
}
